import React from 'react';
import { PropTypes } from 'prop-types';
import { useField } from 'formik';
import classnames from 'classnames';
import Asterisk from '../Asterisk/index';
import { H5, LabelSmall, LinkText } from '@styled';

const Radios = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const { name, options, required, instructions, onChange } = props;

    // remove so it isn't passed to input
    // eslint-disable-next-line react/destructuring-assignment
    delete props.options;

    const hasError = meta.touched && meta.error;

    const groupClasses = classnames('form-group');

    return (
        <div className={groupClasses}>
            <div>
                {label && (
                    <H5 className="mb-0.5rem">
                        {label} {required && <Asterisk />}
                    </H5>
                )}

                {instructions && (
                    <div className="mb-0.5rem">
                        <LabelSmall>{instructions}</LabelSmall>
                    </div>
                )}
            </div>

            {options.map(option => (
                <div key={option.value} className="form-radio">
                    <label
                        className="form-radio-label d-flex align-items-center"
                        htmlFor={`radio-${name}-${option.value}`}
                    >
                        <input
                            id={`radio-${name}-${option.value}`}
                            className="form-radio-input mr-0.5rem"
                            name={name}
                            type="radio"
                            value={option.value}
                            checked={field.value === option.value}
                            onChange={e => {
                                field.onChange(e);
                                if (onChange) {
                                    onChange(e);
                                }
                            }}
                            onBlur={field.onBlur}
                        />{' '}
                        <LinkText>{option.label}</LinkText>
                    </label>
                </div>
            ))}
            {hasError ? <div className="error-msg">{meta.error}</div> : null}
        </div>
    );
};

Radios.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.array,
    required: PropTypes.bool,
    instructions: PropTypes.string,
    onChange: PropTypes.func,
};

export default Radios;
